export default "__VITE_ASSET__B9Xw9HR2__"